import { Flex } from "@chakra-ui/react";
import { Header } from "./components/Header";
import { Introduce } from "./components/Introduce";
import { About } from "./components/About";
import { Projects } from "./components/Projects";

function App() {
  return (
    <>
      <Flex flexDir="column" overscrollY="none">
        <Header/>
        <Introduce/>
        <Projects/>
        <About/>
      </Flex>
    </>
  );
}

export default App;
